import { getIsOnpremise } from '../utils';
import { useCloudNetworkStatus } from './useCloudNetworkStatus';
import { useOnPremiseNetworkStatus } from './useOnPremiseNetworkStatus';
export var useNetworkStatus = function useNetworkStatus() {
  var isOnPremise = getIsOnpremise();
  if (isOnPremise) {
    return useOnPremiseNetworkStatus();
  } else {
    return useCloudNetworkStatus();
  }
};
export default useNetworkStatus;